const LogoutIcon = () => {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2114_35105)">
                <path
                    d="M8.50004 14.6667C4.81804 14.6667 1.83337 11.682 1.83337 8.00001C1.83337 4.31801 4.81804 1.33335 8.50004 1.33335C9.53515 1.33257 10.5562 1.57319 11.482 2.03611C12.4078 2.49902 13.2129 3.17146 13.8334 4.00001H12.0267C11.2569 3.32119 10.3075 2.87892 9.29252 2.72628C8.27754 2.57364 7.24008 2.71712 6.30463 3.13949C5.36918 3.56186 4.57547 4.24519 4.01875 5.10747C3.46203 5.96975 3.16595 6.97436 3.16604 8.00075C3.16612 9.02714 3.46237 10.0317 4.01924 10.8939C4.5761 11.7561 5.36992 12.4393 6.30544 12.8615C7.24097 13.2837 8.27845 13.427 9.2934 13.2742C10.3083 13.1214 11.2576 12.679 12.0274 12H13.834C13.2135 12.8287 12.4083 13.5012 11.4824 13.9641C10.5564 14.427 9.53526 14.6676 8.50004 14.6667ZM13.1667 10.6667V8.66668H7.83337V7.33335H13.1667V5.33335L16.5 8.00001L13.1667 10.6667Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_2114_35105">
                    <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LogoutIcon;
